import Config from '@/config/index';
const useConfig = () => {
    return {
        ...Config,
    };
};
export default useConfig;
